import { call, put, takeLatest } from "redux-saga/effects";
import {
    addSpecialistFailure,
    addSpecialistSuccess,
    deleteSpecialistFailure,
    deleteSpecialistSuccess,
    fetchSpecialistFailure,
    fetchSpecialistsFailure,
    fetchSpecialistsSuccess,
    fetchSpecialistSuccess,
    updateSpecialistFailure,
    updateSpecialistSuccess,
} from "./specialistAction";
import {
    addSpecialistEffect,
    deleteSpecialistEffect,
    editSpecialistEffect,
    listSpecialistEffect,
    viewSpecialistEffect,
} from "./specialistEffect";
import {
    ADD_SPECIALIST_REQUEST,
    DELETE_SPECIALIST_REQUEST,
    FETCH_LIST_SPECIALIST_REQUEST,
    FETCH_SPECIALIST_REQUEST,
    UPDATE_SPECIALIST_REQUEST,
} from "./specialistType";

function* fetchSpecialistsSaga(action) {

    try {
        const specialists = yield call(listSpecialistEffect,action.payload); 
        yield put(fetchSpecialistsSuccess(specialists));
    } catch (error) {
        yield put(fetchSpecialistsFailure(error.message));
    }
}

function* fetchSpecialistSaga(action) {
    try {
        const specialist = yield call(viewSpecialistEffect, action.payload.specialistId);
        yield put(fetchSpecialistSuccess(specialist));
    } catch (error) {
        yield put(fetchSpecialistFailure(error.message));
    }
}

function* addSpecialistSaga(action) {
    try {
        const newSpecialist = yield call(addSpecialistEffect, action.payload.specialistData);
        yield put(addSpecialistSuccess(newSpecialist));
    } catch (error) {
        yield put(addSpecialistFailure(error.message));
    }
}

function* updateSpecialistSaga(action) {
    try {
        const updatedSpecialist = yield call(
            editSpecialistEffect,
            action.payload.specialistId,
            action.payload.specialistData
        );
        yield put(updateSpecialistSuccess(updatedSpecialist));
    } catch (error) {
        yield put(updateSpecialistFailure(error.message));
    }
}

function* deleteSpecialistSaga(action) {
    try {
        yield call(deleteSpecialistEffect, action.payload.specialistId);
        yield put(deleteSpecialistSuccess(action.payload.specialistId));
    } catch (error) {
        yield put(deleteSpecialistFailure(error.message));
    }
}

export function* specialistSagas() {
    yield takeLatest(FETCH_LIST_SPECIALIST_REQUEST, fetchSpecialistsSaga);
    yield takeLatest(FETCH_SPECIALIST_REQUEST, fetchSpecialistSaga);
    yield takeLatest(ADD_SPECIALIST_REQUEST, addSpecialistSaga);
    yield takeLatest(UPDATE_SPECIALIST_REQUEST, updateSpecialistSaga);
    yield takeLatest(DELETE_SPECIALIST_REQUEST, deleteSpecialistSaga);
}